module.exports = __webpack_public_path__ + "static/ForTheKing3-b6bd9410f19aee09c95f551af92b8966.webp";